import { Row } from "antd";
import React from "react";

const DecodeCD = ({ data }) => {
  if (data) {
    // Tách danh sách ung thư thành mảng các đối tượng
    const cancers = data.split("\n").map((item) => {
      const [code, ...rest] = item.split(" ");
      const name = rest.join(" "); // Nối lại phần còn lại của mảng thành tên
      return { code, name };
    });

    return (
      <div>
        {cancers.map(
          (cancer) =>
            cancer.code &&
            cancer.name && (
              <Row key={cancer.code}>{`${cancer.code} - ${cancer.name}`}</Row>
            )
        )}
      </div>
    );
  }
};

export default DecodeCD;
